import smoothscroll from "smoothscroll-polyfill";
import { componentsLoader } from "../components/_loader";

componentsLoader();

window.addEventListener("load", () => {
	window.dispatchEvent(new CustomEvent("mediaLoaded"));
});

smoothscroll.polyfill();
